'use client'
import React from 'react'
import {Divider} from '@heroui/react'
import {signOut} from 'next-auth/react'

import {
  advisorMenuContent,
  clientMenuContent,
} from '@/components/AdvisorAccount/SideMenu/constants'
import Box from '@/components/UI/Box/Box'
import Icon from '@/components/UI/Icon/Icon'
import MenuLink from '@/components/UI/MenuLink/MenuLink'
import {Body6} from '@/components/UI/Typography'

import {CustomerSummary} from '@/src/services/UserService/types'

const NavCustomerPopover = ({
  customerSummary,
}: {
  customerSummary: CustomerSummary | null
}) => {
  const menuRenderer = () => {
    if (customerSummary) {
      if (customerSummary.advisorStatus) {
        return (
          <>
            {advisorContent}
            {clientContent}
          </>
        )
      }
      return clientContent
    }
    return nonLoginContent
  }

  const advisorContent = (
    <>
      <Box className="flex-col gap-2 pt-4 pb-2">
        <Body6 className="font-semibold">Danışman Hesabım</Body6>
        <Box className="flex-col">
          {advisorMenuContent.map((menu, index) => (
            <MenuLink key={index} href={menu.href}>
              <Box className="items-center gap-2">
                <Icon className="fill-primary" size={16} name={menu.iconName} />
                <Body6>{menu.text}</Body6>
              </Box>
            </MenuLink>
          ))}
        </Box>
      </Box>
      <Divider />
    </>
  )
  const clientContent = (
    <Box className="flex-col">
      <Box className="flex-col pt-4 pb-2 gap-2">
        <Body6 className="font-semibold">Danışan Hesabım</Body6>
        <Box className="flex-col">
          {clientMenuContent.map((menu, index) => (
            <MenuLink key={index} href={menu.href}>
              <Box className="items-center gap-2">
                <Icon className="fill-primary" size={16} name={menu.iconName} />
                <Body6>{menu.text}</Body6>
              </Box>
            </MenuLink>
          ))}
        </Box>
      </Box>
      <Divider />
      <Box className="pt-4 pb-2 w-full">
        <MenuLink
          key="logout"
          href="/"
          className="w-full"
          onClick={() => signOut({callbackUrl: '/', redirect: true})}>
          <Box className="items-center gap-2">
            <Icon size={16} className="fill-primary" name="logout" />
            <Body6>Çıkış Yap</Body6>
          </Box>
        </MenuLink>
      </Box>
    </Box>
  )
  const nonLoginContent = (
    <Box className="flex-col w-full pb-2">
      <MenuLink key="login" className="py-2 w-full" href="/giris">
        <Box className="items-center gap-2">
          <Icon size={20} className="fill-primary" name="login" />
          <Body6>Giriş Yap</Body6>
        </Box>
      </MenuLink>
      <MenuLink key="signIn" className="py-2" href="/kayit-ol">
        <Box className="items-center gap-2">
          <Icon size={20} className="fill-primary" name="addItem" />
          <Body6>Kayıt Ol</Body6>
        </Box>
      </MenuLink>
    </Box>
  )

  return (
    <Box className="flex-col w-full">
      <Body6 className="text-primary py-2">
        {customerSummary?.firstName && customerSummary?.lastName
          ? `${customerSummary.firstName} ${customerSummary.lastName}`
          : customerSummary?.email}
      </Body6>
      {customerSummary && <Divider />}
      {menuRenderer()}
    </Box>
  )
}

export default NavCustomerPopover
